
import { PropType, computed, defineComponent, getCurrentInstance, nextTick, onMounted, ref, watch } from 'vue'
import merge from 'lodash/merge'
import first from 'lodash/first'
import omitBy from 'lodash/omitBy'
import TextField from '../../inputs/TextField.vue'
import CustomActivatorSelect from '../../inputs/CustomActivatorSelect.vue'
import BaseInputOutlined from '../../inputs/BaseInputOutlined.vue'
import api from '../../../api/api'
import useRouter from '../../../hooks/useRouter'
import { Project } from '../../../types/main'
import { ScheduledReportData, ScheduledReportTemplate } from '../../../types/scheduledReport'
import { checkInputIsIntNumber } from '@/utils'
import { telephonyService } from '@/services/telephony'
import { checkModuleIsActive, checkRole } from '../../../helpers/roles'
import { CONNECTOR_TYPES } from '@root/src/vars/general'
export default defineComponent({
    props: {
        value: {
            type: Object as PropType<ScheduledReportData>,
            required: true,
        },
        scheduledReportTemplates: {
            type: Array as PropType<ScheduledReportTemplate[]>,
            required: true,
        },
    },
    components: { TextField, CustomActivatorSelect, BaseInputOutlined },
    setup(props, { emit }) {
        const root = getCurrentInstance()!.proxy
        const loading = ref(true)
        const { route } = useRouter(root)
        const formIsValid = ref()
        const activeadditionalParams = ref<string[]>([])
        const project = computed<Project>(() => root.$store.getters.projectById(route.value.params.id))

        watch(formIsValid, v => {
            nextTick(() => {
                emit('validation-updated', v)
            })
        })
        const update = (val: any, key: string) => {
            // Если меняется templateId, и новый templateId не равен 51 или 8, и sendChannels содержит "telegramHrBranch", то очищаем sendChannels
            if (key === 'templateId' && val !== 51 && val !== 8 && Array.isArray(props.value.sendChannels) && props.value.sendChannels.includes('telegramHrBranch')) {
                emit('input', Object.assign({}, props.value, { [key]: val, sendChannels: [] }))
            } else {
                emit('input', Object.assign({}, props.value, { [key]: val }))
            }
        }

        const availableScheduledReportTemplates = computed(() =>
            props.scheduledReportTemplates.map(el => {
                if (
                    el.type === 'weekly' &&
                    !checkModuleIsActive(project.value.id, 'project:scheduledReport:weekly')
                ) {
                    return { ...el, disabled: true, disabledText: 'Не входит в тариф' }
                }
                if (
                    (el.type === null || el.type === 'daily') &&
                    !checkModuleIsActive(project.value.id, 'project:scheduledReport:daily')
                ) {
                    return { ...el, disabled: true, disabledText: 'Не входит в тариф' }
                }
                return el
            })
        )
        const activeAdditionalParams = computed(() => {
            const activeTemplate = props.scheduledReportTemplates.find(el => el.id === props.value.templateId)
            return activeTemplate?.additionalParams || []
        })
        const activeTemplate = computed(() => {
            return props.scheduledReportTemplates.find(el => el.id === props.value.templateId)
        })
        const adminPlanLabel = computed(() => {
            if (activeTemplate.value?.type === 'weekly') {
                return 'План звонков на неделю'
            }
            if (activeTemplate.value?.functionName === 'notification_everyday_report') {
                return 'План коммуникаций на день'
            }
            return 'План звонков на день'
        })
        watch(
            () => props.value.templateId,
            (newTemplateId, oldTemplateId) => {
                // Если новый templateId не равен 51 или 8, и sendChannels содержит "telegramHrBranch", то очищаем sendChannels
                // Проверяем только если templateId действительно изменился
                if (newTemplateId !== oldTemplateId && newTemplateId !== 51 && newTemplateId !== 8 && 
                    Array.isArray(props.value.sendChannels) && props.value.sendChannels.includes('telegramHrBranch')) {
                    nextTick(() => {
                        emit('input', Object.assign({}, props.value, { sendChannels: [] }))
                    })
                }

                activeadditionalParams.value = activeTemplate.value?.additionalParams || []
                if (activeadditionalParams.value.includes('targetUser') && telephonyUsers) {
                    update(
                        merge(props.value.additionalParamsValues, {
                            targetUser: first(telephonyUsers.value)?.id,
                        }),
                        'additionalParamsValues'
                    )
                }

                nextTick(() => {
                    update(
                        omitBy(
                            props.value.additionalParamsValues,
                            (value, key) => !activeadditionalParams.value.includes(key)
                        ),
                        'additionalParamsValues'
                    )
                })
            }
        )

        const telephonyUsers = computed(() => {
            const telephonyConnector = telephonyService.getTelephonyConnector(project.value.connectors)
            if (!telephonyConnector) return null

            const uniqueIds = [...new Set(Object.values(telephonyConnector?.usersMapping))]
            const usersMapping = uniqueIds.map(id => ({ id, title: id }))

            if (telephonyConnector.connectorType === CONNECTOR_TYPES.telephonyMango) {
                usersMapping.push({
                    id: '',
                    title: 'Все',
                })
            }

            return usersMapping
        })

        onMounted(async () => {
            emit('validation-updated', formIsValid.value)
        })
        const clear = () => {
            nextTick(() => {
                emit('validation-updated', false)
            })
        }
        return {
            update,
            loading,
            clear,
            activeAdditionalParams,
            telephonyUsers,
            checkInputIsIntNumber,
            formIsValid,
            adminPlanLabel,
            availableScheduledReportTemplates,
        }
    },
})
